export class Remarks {
  operationalRemarks: string = undefined;
  hazmatEmergencyContactInfo: string = undefined;
  pieceCount: string = undefined;
  osdContact: string = undefined;
}
